require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-colombia-and-the-world-banks-territorial-development-1.json") })
        }
      }, "path---es-mx-update-colombia-and-the-world-banks-territorial-development-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-colombia-and-the-world-banks-territorial-development-1!./.cache/json/es-mx-update-colombia-and-the-world-banks-territorial-development-1.json
// module id = 921
// module chunks = 231608221292675